// extracted by mini-css-extract-plugin
export default {"imageWrapper":"iF-z","hovered":"jF-z","hoverImage":"kF-z","mainImage":"lF-z","imageNoBackground":"mF-z","fullSizeImage":"nF-z"};